import DashedLine from "features/CenterContent/VehicleDetails/shared/DashedLine";
import { Children, Fragment } from "react";
import { VariantColor } from "shared/utils/colorUtils";
import { FCWC } from "shared/utils/FCWC";

type DashedLinesGapProps = {
  variant: VariantColor;
};

/**
 * Adds a DashedLine between each children.
 *
 * NB: This component needs to be used directly near the children.
 * Passing the children in an other manner (say packing them in a fragment or
 * functional component) results in Children.toArray not recognizing each child.
 */
export const DashedLinesGap: FCWC<DashedLinesGapProps> = ({
  children,
  variant,
}) => (
  <>
    {Children.toArray(children).map((it, i) => (
      // eslint-disable-next-line react/no-array-index-key -- Generic component, so we dont have anything else to go by. These should not be reordered
      <Fragment key={`dashedLinesGap_${i}`}>
        {i > 0 && <DashedLine variant={variant} />}
        {it}
      </Fragment>
    ))}
  </>
);
